export default "__VITE_ASSET___zB$br3V__"